module.exports = {
    "dismiss": `Odstranit`
};


//# sourceMappingURL=cs-CZ.main.js.map
